module.exports = __webpack_public_path__ + "img/icono-acceso.126681db.png";